module.exports = __webpack_public_path__ + "img/logo-alegra-footer.8a87a2bc.svg";